import { createContext, Dispatch, useContext } from 'react';

import type { Action } from '@lumapps/redux';

import {
    NavigationAdminFiltersState,
    initialState,
    NavigationAdminFiltersActions,
} from '../ducks/navigationAdminFilterSlice';

export type NavigationListFiltersContextType = NavigationAdminFiltersState;

/** Create a Context store the current navigation filters */
export const NavigationListFiltersContext = createContext<NavigationListFiltersContextType>(initialState);

export type NavigationListFiltersContextDispatchType = Dispatch<Action<NavigationAdminFiltersActions>>;

/** Create a Context to store the dispatch function to update the navigation filters */
export const NavigationListFiltersDispatchContext = createContext<NavigationListFiltersContextDispatchType>(() => null);

/** Hook to get the Navigation List Filters Context */
export const useNavigationListFilters = () => {
    return useContext(NavigationListFiltersContext);
};

/** Hook to update the Navigation List Filters */
export const useNavigationListFiltersDispatch = () => {
    return useContext(NavigationListFiltersDispatchContext);
};
